import { render, staticRenderFns } from "./ground.vue?vue&type=template&id=63967b1e&scoped=true&"
import script from "./ground.vue?vue&type=script&lang=js&"
export * from "./ground.vue?vue&type=script&lang=js&"
import style0 from "./ground.vue?vue&type=style&index=0&id=63967b1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63967b1e",
  null
  
)

export default component.exports